import { NAME_PERSONAL_INFO, NAME_SHIPPING_INFO, NAME_CONTENT_AGREEMENT, NAME_NETWORKS, NAME_PRODUCTS, NAME_TASKS } from './activation-brief-steps';
import { NO_SHIPPING_ADDRESS, NO_TASKS_SELECTED, NO_PRODUCTS_SELECTED, MAX_PRODUCTS_EXCEEDED, MAX_PRICE_EXCEEDED, MISSING_REQUIRED_NETWORKS, MISSING_REQUIRED_TASKS, MISSING_PHONE_NUMBER, NO_TERMS_AGREEMENT, OUT_OF_STOCK } from './activation-brief-error-codes';
export const STEP_ERROR_MESSAGES = {
    [NAME_NETWORKS]: {
        [MISSING_REQUIRED_NETWORKS]: 'Please connect the required social networks'
    },
    [NAME_PERSONAL_INFO]: {
        [MISSING_PHONE_NUMBER]: 'Please provide the following information'
    },
    [NAME_PRODUCTS]: {
        [NO_PRODUCTS_SELECTED]: 'Please select your product(s)',
        [OUT_OF_STOCK]: 'Some product selections are out of stock',
        [MAX_PRODUCTS_EXCEEDED]: 'You have exceeded the product quantity limit. Please remove 1 or more products.',
        [MAX_PRICE_EXCEEDED]: 'You have exceeded the product price limit. Please change your product selection.'
    },
    [NAME_SHIPPING_INFO]: {
        [NO_SHIPPING_ADDRESS]: 'Please provide your shipping address'
    },
    [NAME_TASKS]: {
        [MISSING_REQUIRED_TASKS]: 'Review the required tasks',
        [NO_TASKS_SELECTED]: 'Please select at least one task'
    },
    [NAME_CONTENT_AGREEMENT]: {
        [NO_TERMS_AGREEMENT]: 'You must agree to our content agreement'
    }
};
